module.exports = __webpack_public_path__ + "img/programplannericon.510cbe1e.svg";